<app-admin-dashboard>
  <app-change-password/>
</app-admin-dashboard>

